<template>

  <div :class="[$style.formSectionBankCard]">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4 class="textColor"> Card Details</h4>
    </div>
    <FormSectionSavedCards
      v-if="innerValue.cardDataType === 'saved'"
      :cards="cards"
      v-model="innerValue.savedCardId"
      @select="emitChanges('savedCardId')"
    />
    <template v-if="innerValue.cardDataType === 'manual'">
      <UiCardField
        v-model="innerValue.cardNumber"
        ref="cardNumberField"
        name="pan"
        type="tel"
        tabindex="1"
        :class="[$style.formIte043m, { [$style._oneLine]: isOneLine }]"
        :hasError="$isFieldInvalid('innerValue.cardNumber')"
        :errorText="$t('FormSectionBankCard.cardNumberInvalid')"
        @keyup.native="moveFocusToFieldOnComplete('cardNumber', 16, 'expiryDateField')"
        @input="emitChanges('cardNumber')"
      />
      <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
        <UiTextField
          v-model="innerValue.expiryDate"
          ref="expiryDateField"
          mask="##/##"
          type="tel"
          tabindex="2"
          autocomplete="off"
          :class="$style.expiry"
          :hasError="$isFieldInvalid('innerValue.expiryDate')"
          :errorText="$t('FormSectionBankCard.expiryDateInvalid')"
          :label="$t('FormSectionBankCard.expiryDate')"
          @keyup.native="moveFocusToFieldOnComplete('expiryDate', 4, 'cvvField')"
          @keyup.native.delete="moveFocusBackOnEmpty('expiryDate', 'cardNumberField')"
          @input="emitChanges('expiryDate')"
          datathreeds="expiry"
        />
        <UiCvvField
          v-model="innerValue.cvv"
          name="cvv"
          ref="cvvField"
          tabindex="3"
          :hasError="$isFieldInvalid('innerValue.cvv')"
          @keyup.native.delete="moveFocusBackOnEmpty('cvv', 'expiryDateField')"
          @input="emitChanges('cvv')"
        />
      </div>

      <!-- hidden elements -->
      <input  type="text" id="xpan"  ref="xpan"  data-threeds="pan" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;"/>
      <input  type="text" id="xmonth"  ref="xmonth" data-threeds="month" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;"/>
      <input   type="text" id="xyear" ref="xyear" value="" data-threeds="year" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;" />

    <!-- Hidden 3DS billing data fields -->
    <div>
      <input type="hidden" id="x3ds-name" data-threeds="cardHolderName" />
      <input type="hidden" id="x3ds-email" data-threeds="email" />
      <input type="hidden" id="x3ds-address1" data-threeds="billingLine1" />
      <input type="hidden" id="x3ds-city" data-threeds="billingCity" />
      <input type="hidden" id="x3ds-state" data-threeds="billingState" />
      <input type="hidden" id="x3ds-zip" data-threeds="billingPostCode" />
      <input type="hidden" id="x3ds-country" value="840" data-threeds="billingCountry" />
    </div>
    </template>

    <SavedCardToPlainFieldsSwitch
      v-if="cards.length"
      v-model="innerValue.cardDataType"
      @change="focusCardNumberField"
    />

    <span v-if="this.statementDesc" style="font-size:12px">This charge will appear as the following on your credit card statement: "{{this.statementDesc}}" </span>

    <span v-if="!this.statementDesc" style="font-size:12px">This charge will appear as the following on your credit card statement: "{{this.name}}" </span>


    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4>Billing Address</h4>
    </div>


<div v-if="testhide" class="billingfields">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <UiTextField
        v-model="innerValue.firstname"
        name="First Name"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.firstname')"
        :hasError="$isFieldInvalid('innerValue.firstname')"
        :errorText="$t('FormSectionBankCard.firstnameInvalid')"
        tabindex="4"
        @input="emitChanges('firstname')"
      />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

      <UiTextField
        v-model="innerValue.lastname"
        name="Last Name"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.lastname')"
        :hasError="$isFieldInvalid('innerValue.lastname')"
        :errorText="$t('FormSectionBankCard.lastnameInvalid')"
        tabindex="5"
        @input="emitChanges('lastname')"
      />
    </div>


  <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
    <UiTextField
      v-model="innerValue.addressline1"
      name="Address Line 1"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.addressline1')"
      :hasError="$isFieldInvalid('innerValue.addressline1')"
      :errorText="$t('FormSectionBankCard.addressline1Invalid')"
      tabindex="6"
      @input="emitChanges('addressline1')"
    />

    <UiTextField
      v-model="innerValue.addressline2"
      name="Address Line 2"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.addressline2')"
      :hasError="$isFieldInvalid('innerValue.addressline2')"
      :errorText="$t('FormSectionBankCard.addressline2Invalid')"
      tabindex="7"
      @input="emitChanges('addressline2')"
    />
  </div>

  <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
    <UiTextField
      v-model="innerValue.city"
      name="city"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.city')"
      :hasError="$isFieldInvalid('innerValue.city')"
      :errorText="$t('FormSectionBankCard.cityInvalid')"
      tabindex="8"
      @input="emitChanges('city')"
    />

      <UiSelect
        name="state"
        v-model="innerValue.state"
        maxHeight="240px"
        style="width: 50%;"
        :options="states"
        :placeholderLabel="$t('FormSectionBankCard.state')"
        :hasReversible="true"
        :hasError="$isFieldInvalid('innerValue.state')"
        :errorText="$t('FormSectionBankCard.stateInvalid')"
        tabindex="9"
        @select="emitChanges('state')"
      />
  </div>

    <UiTextField
        v-model="innerValue.zip"
        name="zip"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.zip')"
        :hasError="$isFieldInvalid('innerValue.zip')"
        :errorText="$t('FormSectionBankCard.zipInvalid')"
        tabindex="10"
        @input="emitChanges('zip')"
      />

    <UiTextField
            v-model="innerValue.email"
            name="email"
            :class="$style.formItem"
            :label="$t('FormSectionBankCard.email')"
            :hasError="$isFieldInvalid('innerValue.email')"
            :errorText="$t('FormSectionBankCard.emailInvalid')"
            tabindex="11"
            @input="emitChanges('email')"
        />

    <span v-if="!this.dynamicAmount && this.surcharge > 0.0" style="font-size:12px; font-weight:bold">Merchant has applied a Convenience fee of ${{this.surcharge/100}} USD to this transaction. </span>
    <span v-if="this.dynamicAmount && this.surchargePercentage > 0.0" style="font-size:12px; font-weight:bold">Merchant has applied a Convenience fee of {{this.surchargePercentage}}% to this transaction. </span>
  </div>
 </div>


</template>

<script>
import {
  email,
  required,
  maxLength,
  minLength,
} from 'vuelidate/lib/validators';
import { toInteger, extend } from 'lodash-es';
import { threeDsEndpoint } from '@/constants';
import getCardSystemType from '@/helpers/getCardSystemType';
import FormSectionSavedCards from '@/components/FormSectionSavedCards.vue';
import SavedCardToPlainFieldsSwitch from '@/components/SavedCardToPlainFieldsSwitch.vue';
import UiSelect from './UiSelect.vue';
import UiTextField from './UiTextField.vue';
import UiCardField from './UiCardField.vue';
import UiSimplePreloader from './UiSimplePreloader.vue';
import UiSelectOption from './UiSelectOption.vue';
import UiCvvField from './UiCvvField.vue';

function isValidExpiryDate(date) {
  if (date.length < 2) {
    return true;
  }
  if (date.length === 2 || date.length === 3) {
    const month = toInteger(date.substring(0, 2));

    if (month < 1 || month > 12) {
      return false;
    }

    return true;
  }
  if (date.length > 4) {
    return false;
  }

  const month = toInteger(date.substring(0, 2));
  const year = toInteger(date.substring(2));

  if (month < 1 || month > 12 || year < 0 || year > 99) {
    return false;
  }

  return true;
}

// The PAAY SDK polls GET /transaction/{id}/updates as a ~15s long-poll. Every 15s the
// cardholder still hasn't finished the challenge, that poll returns 404 and the SDK fires
// our reject() callback — even though it KEEPS polling and will resolve() once the
// cardholder completes. So a reject while the challenge iframe is on screen is just a
// long-poll window expiring and must be ignored; settling there charges mid-challenge.
const THREE_DS_CHALLENGE_IFRAME_ID = 'threeds-challenge-iframe';
// Backstop: if the cardholder abandons the challenge the SDK polls forever and never
// resolves, so cap how long we wait before failing the verify.
const THREE_DS_MAX_WAIT_MS = 5 * 60 * 1000;

export default {
  name: 'FormSectionBankCard',

  components: {
    UiCvvField,
    UiSelectOption,
    UiSimplePreloader,
    UiCardField,
    UiTextField,
    UiSelect,
    FormSectionSavedCards,
    SavedCardToPlainFieldsSwitch,
  },

  props: {
    cardNumberValidator: {
      required: true,
      type: RegExp,
    },
    /**
       * @typedef {{ cardNumber: string, expiryDate: string }} Card
       * @type {Card[]}
       */
    cards: {
      default: () => [],
      type: Array,
    },
    value: {
      type: Object,
    },
    isZipFieldExposed: {
      type: Boolean,
      required: true,
    },
    isZipInvalid: {
      type: Boolean,
      required: true,
    },
    isOneLine: {
      type: Boolean,
      default: false,
    },
    isPayEnabled: {
      type: Boolean,
      default: false,
    },
    merchantPayApiKey: {
      type: String,
      default: '',
    },
    threeDsMode: {
      type: String,
      default: 'disabled',
      validator: (value) => ['disabled', 'data_only', 'required'].includes(value),
    },
    isCvvOptional: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAddressOptional: {
      type: Boolean,
      required: true,
      default: true,
    },
    statementDesc: {
      type: String,
      default: '',
    },
    surcharge: {
      type: Number,
      default: 0.0,
    },
    surchargePercentage: {
      type: Number,
      default: 0.0,
    },
    dynamicAmount: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  data() {
    return {
      states: [
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' },
        { label: 'American Samoa', value: 'AS' },
        { label: 'District of Columbia', value: 'DC' },
        { label: 'Federated States of Micronesia', value: 'FM' },
        { label: 'Guam', value: 'GU' },
        { label: 'Marshall Islands', value: 'MH' },
        { label: 'Northern Mariana Islands', value: 'MP' },
        { label: 'Palau', value: 'PW' },
        { label: 'Puerto Rico', value: 'PR' },
        { label: 'Virgin Islands', value: 'VI' },
      ],
      innerValue: extend({}, this.value),
      isCvvInfoShown: false,
      isRememberInfoShown: false,
      innerExpiryDate: '',
      testhide: true,
    };
  },

  watch: {
    value: {
      handler(value) {
        extend(this.innerValue, value);
      },
      deep: true,
    },
    // The hidden 3DS fields only exist while in manual-card mode. When the user
    // switches in from saved-card mode they render empty, so re-seed them.
    'innerValue.cardDataType': {
      handler(type) {
        if (type === 'manual' && this.isPayEnabled) {
          this.$nextTick(() => {
            this.populateThreeDsBillingFields();
          });
        }
      },
    },
  },

  validations() {
    let innerValue = {
      email: {
        required,
        email,
      },
    };
    if (this.innerValue.cardDataType === 'manual') {
      innerValue = {
        ...innerValue,
        cardNumber: {
          required,
          wrongFormatType(value) {
            return this.cardNumberValidator.test(value);
          },
        },
        expiryDate: { required, isValidExpiryDate },

        cvv: {
          minLength: minLength(3),
          maxLength: maxLength(4),
        },
        zip: {
          wrongValue(value) {
            return (/(^\d{5}$|^\d{5}-\d{4}$)|^[\s]*$/).test(value);
          },
        },
        firstname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
        lastname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
      };
    }

    if (this.isCvvOptional) {
      innerValue = {
        ...innerValue,
        cvv: {
          wrongValue() {
            return !this.isCvvInvalid;
          },
        },
      };
    } else {
      innerValue = {
        ...innerValue,
        cvv: {
          required,
          wrongValue() {
            return !this.isCvvInvalid;
          },
        },
      };
    }


    // address validation
    if (this.isAddressOptional) {
      innerValue = {
        ...innerValue,
        addressline1: {
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        addressline2: {
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        zip: {
          wrongValue() {
            return !this.isZipInvalid;
          },
        },
        city: {
          minLength: minLength(3),
          maxLength: maxLength(100),
        },
      };
    } else {
      innerValue = {
        ...innerValue,
        addressline1: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        addressline2: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        zip: {
          required,
          wrongValue() {
            return !this.isZipInvalid;
          },
        },
        city: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100),
        },
        state: {
          required,
        },
      };
    }


    return {
      innerValue,
    };
  },

  mounted() {
    this.focusCardNumberField();
    if (this.isPayEnabled && this.threeDsMode !== 'disabled') {
      const vueCmp = this;

      this.tds = new ThreeDS(
        'billing-form',
        vueCmp.merchantPayApiKey,
        null,
        {
          endpoint: threeDsEndpoint,
          verbose: true,
          // Don't auto-fire on field blur. We call verify() explicitly on the Pay
          // click so 3DS runs with complete billing data and at the expected time
          // (not mid-form on card entry). autoSubmit:false requires allowRetry off
          // (SDK config rule), so set both explicitly rather than rely on defaults.
          autoSubmit: false,
          allowRetry: false,
          // showChallenge is set per-order from threeDsMode: required=true (show
          // the iframe when the issuer demands a challenge), data_only=false
          // (SDK still runs auth, but no challenge iframe is shown). The SDK
          // only auto-shows the challenge when response.scaIndicator is true;
          // for our merchant it's false, so without showChallenge:true the
          // iframe is created then immediately hidden and the shopper never
          // sees it. Give it a fixed id so it can be styled (see
          // #threeds-challenge-iframe CSS).
          popup: false,
          showChallenge: this.threeDsMode === 'required',
          iframeId: THREE_DS_CHALLENGE_IFRAME_ID,
          // Default Data Share signal; for data_only it's refined per card brand just
          // before verify() (see runThreeDsVerify), once the PAN is known. Visa Data Share
          // = VDO via challengeIndicator "06"; Mastercard Identity Check Insights =
          // messageCategory "80" (accepted since SDK build 2025-04-11). required = "01"
          // (no preference; issuer decides, challenge shown).
          challengeIndicator: this.threeDsMode === 'data_only' ? '06' : '01',
          resolve(threeds) {
            const newInnervalue = {
              ...vueCmp.getInnerValue(),
              eci: threeds.eci,
              authenticationValue: threeds.authenticationValue,
              dsTransId: threeds.dsTransId,
              status: threeds.status,
            };
            vueCmp.$emit('change', newInnervalue);
            vueCmp.settleThreeDs(threeds, null);
          },
          reject(error) {
            vueCmp.settleThreeDs(null, error);
          },
        },
      );

      // Seed the hidden 3DS billing fields from any pre-filled values so the
      // SDK has them even before the user edits the form.
      this.$nextTick(() => {
        this.populateThreeDsBillingFields();
      });
    }
  },

  beforeDestroy() {
    // The 3DS backstop timer (and the SDK's own open-ended polling) can outlive the
    // component on navigation / teardown. Clear the timer so it can't call
    // settleThreeDs after the component is gone, and drop any lingering challenge iframe.
    if (this.threeDsTimeoutId) {
      clearTimeout(this.threeDsTimeoutId);
      this.threeDsTimeoutId = null;
    }
    const iframe = document.getElementById(THREE_DS_CHALLENGE_IFRAME_ID);
    if (iframe && iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  },

  methods: {
    getInnerValue() {
      return this.innerValue;
    },
    // Clear any 3DS result fields from the form value so a skipped, errored, or
    // later non-3DS attempt can't submit stale eci/authenticationValue/etc. from a
    // previous 3DS attempt (createPayment always sends these if present).
    clearThreeDsResult() {
      // undefined (not null) so qs.stringify in createPayment OMITS these keys
      // entirely, matching the original non-3DS behavior. null serializes as empty
      // params (eci=), which the backend could read as "3DS present but empty".
      this.$emit('change', {
        ...this.getInnerValue(),
        eci: undefined,
        authenticationValue: undefined,
        dsTransId: undefined,
        status: undefined,
      });
    },
    // Trigger 3DS authentication explicitly on the Pay click. Returns a promise
    // that resolves when it is safe to charge (authenticated, or a 3DS/technical
    // error we proceed through) and rejects only on cardholder failure.
    runThreeDsVerify() {
      return new Promise((resolve, reject) => {
        // Start clean so a skip / 3DS-error path never submits stale 3DS values
        // from a previous attempt; only a successful verify repopulates them.
        this.clearThreeDsResult();
        // 3DS only applies to a manually-entered card: the hidden pan/month/year
        // (and x3ds-*) inputs the SDK reads exist only in manual-card mode. In
        // saved-card mode they're absent, so verify() would fail/hang and leave
        // this promise unsettled — skip it and let the charge proceed.
        if (!this.isPayEnabled || !this.tds || this.innerValue.cardDataType !== 'manual') {
          resolve({ skipped: true });
          return;
        }
        this.threeDsSettle = { resolve, reject };
        // Data Share params are brand-specific and the brand isn't known until the PAN is
        // entered, so set them here — the SDK reads this.options at /authorize build time.
        // Mastercard Identity Check Insights needs messageCategory "80" + challengeIndicator
        // "01" (accepted since SDK build 2025-04-11); Visa (and other brands) use VDO via
        // challengeIndicator "06". Reset both every attempt so a card-brand switch on retry
        // can't carry stale values. Only data_only; required keeps the constructor's "01".
        if (this.threeDsMode === 'data_only' && this.tds.options) {
          const isMastercard = getCardSystemType(this.innerValue.cardNumber) === 'mastercard';
          this.tds.options.messageCategory = isMastercard ? '80' : '01';
          this.tds.options.challengeIndicator = isMastercard ? '01' : '06';
        }
        // Backstop the SDK's open-ended polling: if the cardholder never finishes the
        // challenge, settleThreeDs is never called and the form stays masked forever.
        // force=true bypasses the "challenge still on screen" guard in settleThreeDs.
        this.threeDsTimeoutId = setTimeout(() => {
          this.settleThreeDs(null, { outcome: 'timeout' }, true);
        }, THREE_DS_MAX_WAIT_MS);
        const paybtn = document.getElementById('paybtn');
        const blink = document.getElementById('blinktext');
        if (paybtn) {
          paybtn.disabled = true;
        }
        if (blink) {
          blink.style.display = 'block';
        }
        try {
          this.tds.verify();
        } catch (err) {
          // verify() can throw synchronously (SDK not initialised, missing hidden
          // inputs, unexpected runtime error). No challenge is on screen in that case,
          // so force-settle: in required mode this fails closed; otherwise it proceeds.
          this.settleThreeDs(null, err, true);
        }
      });
    },
    // Is the SDK's challenge iframe currently displayed? A reject() that arrives while it
    // is means the SDK just hit a long-poll 404 (cardholder still working) — it keeps
    // polling and will resolve() when they finish, so we must NOT settle on it.
    isChallengeOnScreen() {
      const iframe = document.getElementById(THREE_DS_CHALLENGE_IFRAME_ID);
      return !!iframe && iframe.style.display !== 'none';
    },
    // Settle the verify() promise. The SDK resolve(response)s on every final status and
    // reject(error)s on transport errors — but it ALSO rejects on each ~15s long-poll
    // 404 while the cardholder is mid-challenge (and keeps polling). So ignore a reject
    // that arrives while the challenge is on screen unless we force it (sync throw /
    // backstop timeout). In `required` mode the merchant mandates 3DS and the backend
    // enforces it, so only an authenticated result (Y/A) may be charged — anything else
    // fails closed here rather than POSTing a charge that is guaranteed to 422. In
    // `data_only` (Data Share) a non-auth result is informational, never a decline, so
    // always proceed.
    settleThreeDs(threeds, error, force = false) {
      if (error && !force && this.isChallengeOnScreen()) {
        return;
      }

      if (this.threeDsTimeoutId) {
        clearTimeout(this.threeDsTimeoutId);
        this.threeDsTimeoutId = null;
      }
      // Drop any lingering challenge iframe (e.g. on backstop timeout the SDK is still
      // polling and the iframe is still up) so it isn't left over the result screen.
      const iframe = document.getElementById(THREE_DS_CHALLENGE_IFRAME_ID);
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }

      const paybtn = document.getElementById('paybtn');
      const blink = document.getElementById('blinktext');
      if (paybtn) {
        paybtn.disabled = false;
      }
      if (blink) {
        blink.style.display = 'none';
      }

      if (!this.threeDsSettle) {
        return;
      }
      const { resolve, reject } = this.threeDsSettle;
      this.threeDsSettle = null;

      const status = threeds && threeds.status;
      const authenticated = status === 'Y' || status === 'A';

      if (this.threeDsMode === 'required') {
        if (authenticated) {
          resolve({ authenticated: true, status });
        } else if (!error && (status === 'N' || status === 'R')) {
          // Cardholder actively failed the challenge.
          reject({ outcome: 'cardholder_failed', status });
        } else {
          // Couldn't complete authentication (transport error, status U, timeout, …).
          reject({ outcome: 'not_authenticated', status });
        }
        return;
      }

      resolve({ authenticated, status });
    },
    // Push pre-filled billing values into the hidden 3DS data fields. emitChanges
    // only writes these on user input, so without an explicit pass they stay empty
    // when the form mounts with data already present (saved card, URL params,
    // browser autofill) — leaving 3DSi to evaluate risk against blank billing data.
    populateThreeDsBillingFields() {
      const setField = (id, value) => {
        const el = document.getElementById(id);
        if (el) {
          el.value = value || '';
        }
      };
      const fullName = `${this.innerValue.firstname || ''} ${this.innerValue.lastname || ''}`.trim();
      setField('x3ds-name', fullName);
      setField('x3ds-email', this.innerValue.email);
      setField('x3ds-address1', this.innerValue.addressline1);
      setField('x3ds-city', this.innerValue.city);
      setField('x3ds-state', this.innerValue.state);
      setField('x3ds-zip', this.innerValue.zip);
    },
    hidemore(event) {
      // this.testhide = !this.testhide;

      const x = document.getElementById('atoggle').getAttribute('class');
      if (x === 'arrow-right') {
        document.getElementById('atoggle').classList.remove('arrow-right');
        document.getElementById('atoggle').classList.add('arrow-down');
      } else {
        document.getElementById('atoggle').classList.remove('arrow-down');
        document.getElementById('atoggle').classList.add('arrow-right');
      }
    },

    focusCardNumberField() {
      this.$nextTick(() => {
        if (this.$refs.cardNumberField) {
          this.$refs.cardNumberField.focus();
        }
      });
    },
    prepareExpiryDate() {
      const [month, year] = this.innerExpiryDate.split('/');
      this.innerValue.expiryDate = `${month}${year.length === 2 ? year : year.substr(-2)}`;
      this.emitChanges('expiryDate');
    },
    moveFocusToFieldOnComplete(fieldValueName, length, nextField) {
      if (this.innerValue[fieldValueName].length === length) {
        this.$refs[nextField].focus();
      }
    },
    moveFocusBackOnEmpty(fieldValueName, prevField) {
      if (this.$refs[prevField] && this.innerValue[fieldValueName].length === 0) {
        this.$refs[prevField].focus();
      }
    },
    emitChanges(key) {
      if (this.isPayEnabled) {
        // evaluate all three input fields and trigger blur when value is right.
        if (key == 'cardNumber') {
          document.getElementById('xpan').value = this.innerValue[key];

          if (this.innerValue[key].length == 16) {
            document.getElementById('xpan').focus();
            document.getElementById('xpan').blur();
            document.getElementById('cardpan').focus();
          }
        }

        if (key == 'expiryDate') {
          document.getElementById('xyear').value = '';
          document.getElementById('xmonth').value = '';

          if (this.innerValue[key].length == 4) {
            const date = this.innerValue[key];

            const month = toInteger(date.substring(0, 2));
            const year = toInteger(date.substring(2));

            if (month < 1 || month > 12 || year < 0 || year > 99) {
              return false;
            }

            if (month) {
              document.getElementById('xmonth').value = month;
              document.getElementById('xmonth').focus();
              document.getElementById('xmonth').blur();
            }

            if (year) {
              document.getElementById('xyear').value = year;
              document.getElementById('xyear').focus();
              document.getElementById('xyear').blur();
            }
          }
        }

        // Sync 3DS billing fields whenever a billing input changes. The hidden
        // x3ds-* inputs only exist in manual-card mode, but the billing fields
        // render in any mode (v-if="testhide"), so route through the null-safe
        // helper — a direct getElementById(...).value would throw in saved-card
        // mode and abort the rest of emitChanges (incl. the 3DS mask trigger).
        const billingKeys = ['firstname', 'lastname', 'email', 'addressline1', 'city', 'state', 'zip'];
        if (billingKeys.includes(key)) {
          this.populateThreeDsBillingFields();
        }
        // 3DS is no longer auto-triggered here on card+expiry completion — it now
        // runs from runThreeDsVerify() on the Pay click (see mounted/submitPaymentForm).
      }


      // For v-model
      this.$emit('change', this.innerValue);
      const value = this.innerValue[key];
      // to watch certain field
      this.$emit(`${key}Change`, value);
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
};
</script>
<style type="text/css">
button#paybtn:disabled {
    background-color: #d0d0d0;
}
/* 3DS challenge iframe (created by the PAAY SDK with id=threeds-challenge-iframe).
   The SDK toggles only display; sizing/positioning is ours. Centered modal so the
   bank challenge is usable instead of the SDK's default ~300x150 inline frame. */
#threeds-challenge-iframe {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 420px;
    height: 470px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background: #fff;
    z-index: 9999;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
}
.3dcardhidden{
  width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;
}

.billingfields {
  width:100%;
}
.arrow-right {
  border: solid #000;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;  transition:  .5s;
  -webkit-transform: rotate(320deg);
  margin-left:3px;
}
.arrow-down{border: solid #000;   transition:  .5s;
    border-width: 0 3px 3px 0;
    display: inline-block;
 margin-left:3px;
    padding: 3px;
    -webkit-transform: rotate(405deg);}
</style>
<style module lang="scss">
  /* arrowdown:after {*/
  /*  content: ' \2B9F';*/
  /*}*/

.formSectionBankCard {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  justify-content: space-between;
}
.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}
.expiry {
  @include if-ltr {
    margin-right: 20px;
  }
}
.hiddenExpiry {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
  width: calc(50% - 10px);

  @include if-rtl {
    left: auto;
    right: 0;
  }
}
.remember {
  padding: 18px 0;
}
.rememberInfo {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  margin: 0 6px;
}


</style>
